var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4281 10.4142C21.2091 9.63316 22.4754 9.63316 23.2565 10.4142L23.586 10.7437C24.367 11.5247 24.367 12.7911 23.586 13.5721L15.9547 21.2034C15.6755 21.4826 15.3199 21.6729 14.9327 21.7503L11.8733 22.3622C11.7334 22.3902 11.61 22.2668 11.638 22.1269L12.2498 19.0675C12.3273 18.6803 12.5176 18.3247 12.7968 18.0455L20.4281 10.4142Z",
    stroke: "#888281"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 11L23 15",
    stroke: "#888281"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.186cf31f41c0a72e668c662c5ec83049.svg";
export { ForwardRef as ReactComponent };